<template>
  <div class="input-source">
    <object
      id="av-player"
      class="tv-player__video"
      type="application/avplayer"
      v-if="getIsTizen"
    ></object>
    <object
      id="av-player"
      class="tv-player__video"
      v-if="getIsLG && getLGVersion >= '5.0'"
    ></object>
    <video
      id="av-player"
      class="tv-player__video"
      v-if="getLGVersion < '5.0'"
    ></video>
    <object
      id="av-player"
      class="tv-player__video"
      type="application/avplayer"
      v-if="getIsOrsay"
    ></object>
    <video
      v-if="!getIsOrsay && !getIsLG && !getIsTizen"
      class="tv-player__video"
      src="https://media.digmedia.net/website/video/rain_264.mp4?_=1"
      muted
      autoplay
      loop
    ></video>
    <transition name="fade">
      <div class="input-source__osd" v-if="showOSD">
        <div class="osd__header">
          <div class="osd-back osd-back--active">
            <Icon color="#f1f1f1"><ArrowLeft></ArrowLeft></Icon> {{ getBack }}
          </div>
          <div class="tv-osd__header-title">{{ source }} {{ port }}</div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import DeviceType from '@/helpers/DeviceType';
import Icon from '@/components/Icon.vue';
import ArrowLeft from '@/assets/icons/WayfinderArrowLeft.vue';
import { keyHandler, KEYS } from '@/mixins/keyHandler';
import router from '@/router';
import { NAV_TYPE } from '@/store/modules/navigation';

export default {
  mixins: [keyHandler],
  components: { Icon, ArrowLeft },
  props: {
    source: String,
    port: Number | String,
    image: String,
    lang: Object,
  },
  emits: {},
  data() {
    return {
      showOSD: true,
      fadeOutTimer: 0,
      osdInterval: null,
      connectedVideoSources: [],
    };
  },
  watch: {
    fadeOutTimer(value) {
      if (value >= 5000) {
        this.showOSD = false;
        clearInterval(this.osdInterval);
        this.fadeOutTimer = 0;
      }
    },
    showOSD(isTrue) {
      if (isTrue) {
        this.handleOSDFadeInOut();
      }
    },
  },
  mounted() {
    this.handleOSDFadeInOut();
    this.init();
  },
  beforeDestroy() {
    if(this.getIsTizen) {
      window.tizen.tvwindow.hide(this.callbackTizen, null, 'MAIN');
      this.removeInputSource();
    }
    if(this.getIsLG) {
      //window.lg.tvwindow.hide(this.callbackLG, null, 'MAIN');
      this.removeInputSource();
    }
    if(this.getIsOrsay) {
      //window.orsay.tvwindow.hide(this.callbackOrsay, null, 'MAIN');
      this.removeInputSource();
    }
  },
  methods: {
    init() {
      this.showInputSource();
    },
    increaseFadeOutTimer() {
      this.fadeOutTimer += 1000;
    },
    handleOSDFadeInOut() {
      this.osdInterval = setInterval(this.increaseFadeOutTimer, 1000);
    },
    callbackTizen(context) {
      this.$store.dispatch('notification/new', {
        title: 'CALLBACK TIZEN',
        message: JSON.stringify(context),
      });
    },
    callbackLG(context) {
      this.$store.dispatch('notification/new', {
        title: 'CALLBACK LG',
        message: JSON.stringify(context),
      });
    },
    callbackOrsay(context) {
      this.$store.dispatch('notification/new', {
        title: 'CALLBACK ORSAY',
        message: JSON.stringify(context),
      });
    },
    callbackTizenVideoSources(videoSource) {
      //console.log('==========callbackTizenVideoSources==========videoSource=>', videoSource);
      this.connectedVideoSources = videoSource.connected;
      try {
        const source = this.connectedVideoSources.find(
          (el) => el.type === this.source && el.number === this.port
        );
        if (!source) { console.error("========VS-ERR", videoSource); return; }
        console.log('SET SRC', source);
        window.tizen.tvwindow.setSource(source, () =>
          console.log('SET SOURCE')
        );
      } catch (error) {
        console.log('COULDNT SET SOURCE: ', error.name, error.message);
      }
    },
    callbackLGVideoSources(videoSource) {
      //console.log('==========callbackTizenVideoSources==========videoSource=>', videoSource);
      this.connectedVideoSources = videoSource.connected;
      try {
        const source = this.connectedVideoSources.find(
          (el) => el.type === this.source && el.number === this.port
        );
        if (!source) return;
        console.log('SET SRC', source);
        window.lg.tvwindow.setSource(source, () =>
          console.log('SET SOURCE')
        );
      } catch (error) {
        console.log('COULDNT SET SOURCE: ', error.name, error.message);
      }
    },
    callbackOrsayVideoSources(videoSource) {
      //console.log('==========callbackTizenVideoSources==========videoSource=>', videoSource);
      this.connectedVideoSources = videoSource.connected;
      try {
        const source = this.connectedVideoSources.find(
          (el) => el.type === this.source && el.number === this.port
        );
        if (!source) return;
        console.log('SET SRC', source);
        window.orsay.tvwindow.setSource(source, () =>
          console.log('SET SOURCE')
        );
      } catch (error) {
        console.log('COULDNT SET SOURCE: ', error.name, error.message);
      }
    },
    showInputSource() {
      if(this.getIsTizen) {
        try {
          window.tizen.systeminfo.getPropertyValue(
            'VIDEOSOURCE',
            this.callbackTizenVideoSources
          );
          //console.log('==========showInputSource==========');
          window.tizen.tvwindow.show(
            this.callbackTizen,
            (err) => {
              console.log('ERROR SHOW WINDOW', err);
            },
            ['0', '0', '100%', '100%'],
            'MAIN',
            'BEHIND'
          );
        } catch (error) {
          console.log(
            'Error name = ' + error.name + ', Error message = ' + error.message
          );
        }
      }
      if(this.getIsLG) {
        /*
        hcap.externalinput.getCurrentExternalInput({
          "onSuccess": function (s) {
              console.log("onSuccess :" +
                  "\n type = " + s.type +
                  "\n index = " + s.index);
          },
          "onFailure": function (f) {
              console.log("onFailure : errorMessage = " + f.errorMessage);
          }
        });
        */
        try {
          /*
          hcap.externalinput.getExternalInputList({
            "onSuccess": function (s) {
                console.log("=====================================onSuccess : list length = " + s.list.length);
                for (var i = 0; i < s.list.length; i++) {
                    console.log("(" + s.list[i].type + "," + s.list[i].index + "," + s.list[i].name + ")");
                }
            },
            "onFailure": function (f) {
                console.log("onFailure : errorMessage = " + f.errorMessage);
            }
          });
          */
          console.log('==========showInputSource==========THIS=', parseInt(this.port));
          hcap.externalinput.isExternalInputConnected({
            "type": hcap.externalinput.ExternalInputType.HDMI,
            "index": this.port - 1,
            "onSuccess": function (s) {
                console.log("onSuccess : isConnected = " + s.isConnected);
                hcap.externalinput.setCurrentExternalInput({
                  "type": hcap.externalinput.ExternalInputType.HDMI,
                  "index": this.port - 1,
                  "onSuccess": function (s) {
                      console.log("onSuccess", s);
                      hcap.externalinput.getCurrentExternalInput({
                        "onSuccess": function (s) {
                            console.log("===onSuccess :" +
                                "\n type = " + s.type +
                                "\n index = " + s.index);
                        },
                        "onFailure": function (f) {
                            console.log("onFailure : errorMessage = " + f.errorMessage);
                        }
                      });
                  },
                  "onFailure": function (f) {
                      console.log("onFailure : errorMessage = " + f.errorMessage);
                  }
                });
            },
            "onFailure": function (f) {
                console.log("onFailure : errorMessage = " + f.errorMessage);
            }
          });
        } catch (error) {
          console.log(
            'Error name = ' + error.name + ', Error message = ' + error.message
          );
        }
      }
      if(this.getIsOrsay) {
        try {
          window.orsay.systeminfo.getPropertyValue(
            'VIDEOSOURCE',
            this.callbackOrsayVideoSources
          );
          //console.log('==========showInputSource==========');
          window.orsay.tvwindow.show(
            this.callbackTizen,
            (err) => {
              console.log('ERROR SHOW WINDOW', err);
            },
            ['0', '0', '100%', '100%'],
            'MAIN',
            'BEHIND'
          );
        } catch (error) {
          console.log(
            'Error name = ' + error.name + ', Error message = ' + error.message
          );
        }
      }
    },
    callbackRemoveTizenVideoSources(videoSource) {
      //console.log('==========callbackRemoveTizenVideoSources==========videoSource=>', videoSource);
      this.connectedVideoSources = videoSource.connected;
      try {
        const source = this.connectedVideoSources.find(
          (el) => el.type === 'TV' && el.number === 1
        );
        if (!source) return;
        console.log('SET SRC', source);
        window.tizen.tvwindow.setSource(source, () =>
          console.log('SET SOURCE')
        );
      } catch (error) {
        console.log('COULDNT SET SOURCE: ', error.name, error.message);
      }
    },
    callbackRemoveLGVideoSources(videoSource) {
      //console.log('==========callbackRemoveTizenVideoSources==========videoSource=>', videoSource);
      this.connectedVideoSources = videoSource.connected;
      try {
        const source = this.connectedVideoSources.find(
          (el) => el.type === 'TV' && el.number === 1
        );
        if (!source) return;
        console.log('SET SRC', source);
        window.lg.tvwindow.setSource(source, () =>
          console.log('SET SOURCE')
        );
      } catch (error) {
        console.log('COULDNT SET SOURCE: ', error.name, error.message);
      }
    },
    callbackRemoveOrsayVideoSources(videoSource) {
      //console.log('==========callbackRemoveTizenVideoSources==========videoSource=>', videoSource);
      this.connectedVideoSources = videoSource.connected;
      try {
        const source = this.connectedVideoSources.find(
          (el) => el.type === 'TV' && el.number === 1
        );
        if (!source) return;
        console.log('SET SRC', source);
        window.orsay.tvwindow.setSource(source, () =>
          console.log('SET SOURCE')
        );
      } catch (error) {
        console.log('COULDNT SET SOURCE: ', error.name, error.message);
      }
    },
    removeInputSource() {
      if(this.getIsTizen) {
        try {
          window.tizen.systeminfo.getPropertyValue(
            'VIDEOSOURCE',
            this.callbackRemoveTizenVideoSources
          );
          //console.log('==========removeInputSource==========');
          window.tizen.tvwindow.show(
            this.callbackTizen,
            (err) => {
              console.log('ERROR SHOW WINDOW', err);
            },
            ['0', '0', '100%', '100%'],
            'MAIN',
            'BEHIND'
          );
        } catch (error) {
          console.log(
            'Error name = ' + error.name + ', Error message = ' + error.message
          );
        }
      }
      if(this.getIsLG) {
        /*
        hcap.externalinput.getExternalInputList({
            "onSuccess": function (s) {
                console.log("onSuccess : list length = " + s.list.length);
                for (var i = 0; i < s.list.length; i++) {
                    console.log("(" + s.list[i].type + "," + s.list[i].index + "," + s.list[i].name + ")");
                }
            },
            "onFailure": function (f) {
                console.log("onFailure : errorMessage = " + f.errorMessage);
            }
        });
        */
        try {
          //console.log('==========removeInputSource==========');
          hcap.externalinput.setCurrentExternalInput({
            "type": hcap.externalinput.ExternalInputType.TV,//COMPONENT OTHERS RGB
            "index": 0,
            "onSuccess": function () {
                console.log("onSuccess");
            },
            "onFailure": function (f) {
                console.log("onFailure : errorMessage = " + f.errorMessage);
            }
          });
        } catch (error) {
          console.log(
            'Error name = ' + error.name + ', Error message = ' + error.message
          );
        }
      }
      if(this.getIsOrsay) {
        try {
          window.orsay.systeminfo.getPropertyValue(
            'VIDEOSOURCE',
            this.callbackRemoveOrsayVideoSources
          );
          //console.log('==========removeInputSource==========');
          window.orsay.tvwindow.show(
            this.callbackTizen,
            (err) => {
              console.log('ERROR SHOW WINDOW', err);
            },
            ['0', '0', '100%', '100%'],
            'MAIN',
            'BEHIND'
          );
        } catch (error) {
          console.log(
            'Error name = ' + error.name + ', Error message = ' + error.message
          );
        }
      }
    },
    eventHandler(key, event) {
      switch (key) {
        case KEYS.ENTER:
          if (!this.showOSD) {
            this.showOSD = true;
            break;
          }
        case KEYS.BACK:
          this.$store.dispatch('navigation/to', NAV_TYPE.BACK);
          break;
        default:
          this.fadeOutTimer = 0;
          this.showOSD = true;
      }
    },
  },
  computed: {
    getIsTizen() {
      return DeviceType.isTizen;
    },
    getLGVersion() {
      return window.lgVersion;
    },
    getIsLG() {
      return DeviceType.isLG;
    },
    getIsOrsay() {
      return DeviceType.isOrsay;
    },
    getBack() {
      return this.$i18n('back.name');
    },
  },
};
</script>

<style scoped>
.input-source {
  /*background: black;*/
  height: 100vh;
  position: relative;
  width: 100vw;
}
.input-source__osd {
  height: 100vh;
  left: 0;
  position: absolute;
  top: 0;
  width: 100vw;
  z-index: 220;
}
.osd__header {
  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0.7),
    transparent 40%,
    transparent
  );
  color: white;
  display: flex;
  font-size: 3vw;
  justify-content: space-between;
  padding: 0 40px;
  height: 120px;
  align-items: center;
}
.input-source__window {
  height: 100%;
  width: 100%;
  z-index: 1;
}

.tv-player__video {
  height: 100%;
  width: 100%;
}

.osd-back {
  font-size: 2vw;
  border: 2px solid transparent;
  padding: 10px 20px;
}
.osd-back--active {
  border-color: #f1f1f1;
}

.fade-enter-active {
  transition: all 0.1s ease-in-out;
}
.fade-leave-active {
  transition: all 0.6s ease-in-out;
}
.fade-leave-to,
.fade-enter {
  opacity: 0;
}
.fade-leave,
.fade-enter-to {
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/pages/InputSource.vue